import { useEffect, useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import SyncIcon from "../../../components/SyncIcon/SyncIcon";
import { useSSEContext } from "../../../contexts/sse";
import { useUserStore } from "../../../contexts/userStore";
import AccessRoutesService from "../../../services/AccessRoutesService";
import "./ListAccessRoutes.css";
import { useAuth } from "../../../contexts/auth";
import { Tag } from "../../../components/Tag/Tag";

export const ListAccessRoutes = (props) => {
   const [accessRoutes, setAccessRoutes] = useState([]);
   const [maxPage, setMaxPage] = useState(1);
   const { selectedCondominio, selectedLicenceId } = useUserStore();
   const [currentPage, setCurrentPage] = useState(1);
   const { sseReceived } = useSSEContext();
   const [collumnClicked, setCollumnClicked] = useState({
      collumnTitle: "createdAt",
      orderDirection: "DESC",
   });
   const [isLoading, setIsLoading] = useState(true);
   const cancelTokenRef = useRef(null);
   const { user } = useAuth();

   const getAccessRoutes = async (
      page,
      searchText,
      organizationId,
      collumnClicked
   ) => {
      if (cancelTokenRef.current) {
         cancelTokenRef.current.abort();
      }
      cancelTokenRef.current = new AbortController();
      setIsLoading(true);
      const response = await AccessRoutesService.listAccessRoutesPaginated(
         page,
         searchText,
         organizationId,
         collumnClicked,
         cancelTokenRef.current.signal
      );
      setIsLoading(false);
      setAccessRoutes(response.data?.items);
      setCurrentPage(page);
      setMaxPage(response.data?.totalPages);
   };

   useEffect(() => {
      getAccessRoutes(
         currentPage,
         props.filters,
         user.userData.selectedOrganizationId,
         collumnClicked
      );
   }, [
      props.filters,
      user.userData.selectedOrganizationId,
      collumnClicked,
      props.refreshKey,
      currentPage
   ]);

   return (
      <>
         <div className="list-container list-visibility">
            <List
               isLoading={isLoading}
               handleCollumnTitleClick={(collumnIndex) =>
                  setCollumnClicked(collumnIndex)
               }
               listEntityName="accessRoutes"
               collumsObjIndex={[
                  { collumnLabel: "Nome", index: "name", type: "text" },
                  {
                     collumnLabel: "Etiquetas",
                     index: "tags",
                     type: "text",
                     custom: ({ row }) => (
                        <>
                           {row.tags && row.tags.length > 0 ? (
                              <div style={{ display: 'flex', gap: '4px' }}>
                                 {row.tags?.map(tag => <Tag key={tag.id} tag={tag} />)}
                              </div>
                           ) : (
                              <span style={{ opacity: 0.4 }}>Nenhuma</span>
                           )}
                        </>
                     )
                  },
                  {
                     collumnLabel: "Habilitado",
                     index: "enabled",
                     type: "enabled",
                  },
               ]}
               data={accessRoutes}
            />
         </div>
         <div className="card-visibility">
            {accessRoutes &&
               accessRoutes.map((accessRoute, index) => (
                  <Card
                     key={index}
                     data={accessRoute}
                     delete={() => AccessRoutesService.deleteAccessRoutes(accessRoute.id)}
                     navigateOnDelete={"../consulta-access-routes"}
                     navigateOnEdit={"../cadastro-access-routes"}
                  >
                     <p className="card-content-title">{accessRoute.name}</p>
                  </Card>
               ))}
         </div>
         {accessRoutes.length > 0 && (
            <Pagination
               rowsPerPage={8}
               maxPage={maxPage}
               changePage={(page) =>
                  setCurrentPage(page)
               }
            />
         )}
      </>
   );
};
